<template>
  <div class="home-maxica">
    <!-- MARQUEE REMOVED (Global in App.vue) -->

    <!-- HERO SECTION PREMIUM WITH OVERLAY PRODUCTS -->
    <section class="hero is-medium hero-premium relative-position">
        <!-- Background Overlay -->
        <div class="hero-overlay-bg"></div>
        
        <div class="hero-body is-flex is-align-items-center">
            <div class="container relative-position z-10 w-100">
                
                <!-- TITLE OVERLAY -->
                <div class="home-section-heading has-text-centered">
                     <h2 class="title is-3 has-text-grey-dark is-uppercase">Destacados</h2>
                </div>

                <!-- PRODUCTS GRID (Overlaying Hero) -->
                <!-- Mobile: is-6-mobile (2 items per row), Larger gap -->
                <div class="columns is-mobile is-multiline is-centered is-variable is-2-mobile is-3-tablet">
                    <div class="column is-6-mobile is-4-tablet is-3-desktop is-one-fifth-widescreen" v-for="prod in productosDestacados" :key="prod.id">
                        <div class="card product-card hero-product-card" @click="irAProducto(prod)">
                            <div class="card-image relative-position">
                                <!-- Changed to square (1by1) for shorter aesthetic as requested -->
                                <figure class="image is-1by1">
                                    <img :src="obtenerFoto(prod)" :alt="prod.nombre" class="product-img" style="object-fit: cover;">
                                    <!-- Hover Overlay only on desktop -->
                                    <div class="overlay-product is-hidden-mobile">
                                        <b-button type="is-black" outlined rounded inverted>VER</b-button>
                                    </div>
                                </figure>
                                <span
                                      v-if="porcentajeDescuento(prod)"
                                      class="tag discount-tag is-absolute-top-left is-uppercase is-size-7-mobile">
                                      -{{ porcentajeDescuento(prod) }}%
                                </span>
                            </div>
                            <div class="card-content has-text-centered pa-2" style="background: transparent;">
                                <p class="title is-6-mobile is-6-desktop mb-0 is-uppercase is-size-7-mobile truncate-text has-text-grey-dark" style="letter-spacing: 0.5px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ prod.nombre }}</p>
                                
                                <div class="price-container">
                                    <template v-if="precioDestacadoDisponible(prod)">
                                        <div class="price-row">
                                            <span class="price-current">${{ formatorPrecio(precioDestacado(prod)) }}</span>
                                            <span v-if="porcentajeDescuento(prod)" class="price-before">${{ formatorPrecio(precioOriginal(prod)) }}</span>
                                        </div>
                                        <div v-if="porcentajeDescuento(prod)" class="price-discount">{{ porcentajeDescuento(prod) }}% de descuento</div>
                                        <div v-if="precioDisponible(prod.precioMayoreo)" class="price-dozen">
                                            Docena: ${{ formatorPrecio(prod.precioMayoreo) }}
                                        </div>
                                    </template>
                                    <span v-else class="price-current">
                                       Consultar precio
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- VER CATALOGO BUTTON -->
                <div class="home-catalog-action has-text-centered">
                    <b-button type="is-dark" rounded outlined @click="$router.push('/tienda')">
                        VER CATÁLOGO
                    </b-button>
                </div>

            </div>
        </div>

    </section>

    <!-- SECTION: CATEGORIAS CON IMAGEN -->
    <section class="section home-collections-section has-background-white-ter">
      <div class="container">
        <h3 class="home-collections-title subtitle is-5 has-text-centered is-uppercase has-text-grey">Colecciones Destacadas</h3>
         
         <div class="columns is-multiline is-mobile is-centered is-variable is-2-mobile">
             <div class="column is-6-mobile is-3-tablet" v-for="(cat, index) in colecciones" :key="index">
                 <div class="card category-card" @click="irACategoria(cat.nombreCategoria)">
                     <div class="card-image">
                         <figure class="image is-1by1">
                             <img :src="obtenerFoto(cat)" :alt="cat.nombreCategoria" style="object-fit: cover;">
                             <div class="category-overlay">
                                 <span class="category-name">{{ cat.nombreCategoria }}</span>
                             </div>
                         </figure>
                     </div>
                 </div>
             </div>
         </div>
         
      </div>
    </section>

    <!-- SECTION: CLIENTES FELICES (Testimonials) -->
    <section class="section section-testimonials" v-if="clientesFelices.length > 0">
      <div class="container">
        <div class="has-text-centered mb-6">
            <h2 class="title is-3">Lo que dicen nuestros clientes</h2>
            <div class="divider mx-auto"></div>
        </div>
        
        <b-carousel-list v-model="currTestimonial" :data="clientesFelices" :items-to-show="3" :arrow="true" :interval="4000" :repeat="true">
            <template slot="item" slot-scope="props">
                <div class="card testimonial-card mx-3">
                    <div class="card-content has-text-centered">
                        <div class="avatar-wrapper mb-4">
                            <figure class="image is-64x64 is-inline-block">
                                <img :src="obtenerUrl(props.list.foto)" class="is-rounded" style="height:64px; width:64px; object-fit:cover;">
                            </figure>
                        </div>
                        <div class="stars has-text-warning mb-3">
                            <i class="mdi mdi-star"></i><i class="mdi mdi-star"></i><i class="mdi mdi-star"></i><i class="mdi mdi-star"></i><i class="mdi mdi-star"></i>
                        </div>
                        <p class="subtitle is-6 is-italic has-text-grey-dark">"{{ props.list.descripcion }}"</p>
                        <p class="title is-6 mt-4">{{ props.list.nombre }}</p>
                    </div>
                </div>
            </template>
        </b-carousel-list>
      </div>
    </section>

  </div>
</template>

<script>
import HttpService from "../Servicios/HttpService";

export default {
  name: "HomeMaxica",
  data() {
    return {
      ajustes: {},
      productosDestacados: [],
      clientesFelices: [],
      colecciones: [], // New
      currTestimonial: 0
    };
  },
  computed: {
      esMayorista() {
          const rol = localStorage.getItem("rol");
          return rol === 'mayorista' || rol === 'administrador' || rol === 'inven';
      }
  },
  mounted() {
    this.cargarDatos();
  },
  methods: {
    async cargarDatos() {
        try {
            const data = await HttpService.registrar("funciones.php", { accion: "obtenerDatosHome" });
            if(data) {
                this.ajustes = data.ajustes || {};
                this.productosDestacados = data.productos_destacados || [];
                this.clientesFelices = data.clientes_felices || [];
            }
            // Fetch Collections (Categories with images)
            this.colecciones = await HttpService.registrar("funciones.php", { accion: "obtenerColecciones" }) || [];
        } catch (e) {
            console.error(e);
        }
    },
    obtenerFoto(prod) {
        if (!prod) return "https://bulma.io/images/placeholders/96x96.png";
        if (prod.imagen) return this.obtenerUrl(prod.imagen); 
        if (prod.imagen1) return this.obtenerUrl(prod.imagen1);
        return "https://maxica.com.co/ximena/imgproductos/" + (prod.codigo || 'default') + ".png";
    },
    obtenerUrl(path) {
        if (!path) return "https://bulma.io/images/placeholders/96x96.png";
        if (path.startsWith('http')) return path;
        
        // Si es una ruta de producto que viene con ../api/
        if (path.includes('../api/')) {
            return path.replace('../api/', 'https://maxica.com.co/ximena/api/');
        }
        
        // Si es una imagen de testimonios (suele estar en imagenes/)
        if (path.startsWith('imagenes/') || path.startsWith('img/')) {
            return "https://maxica.com.co/ximena/" + path;
        }

        // Por defecto, si no tiene nada de lo anterior, probamos en la raíz de ximena
        return "https://maxica.com.co/ximena/" + path.replace(/^\//, '');
    },
    irAProducto(prod) {
        this.$router.push({
            name: "ProductoDetalle",
            params: { id: prod.id, slug: this.slugify(prod.nombre || prod.codigo) }
        });
    },
    irACategoria(cat) {
        this.$router.push({ name: "CatalogoCategoria", params: { slug: this.slugify(cat) } });
    },
    precioDisponible(precio) {
      return Number(precio || 0) > 0;
    },
    precioDestacado(prod) {
      return this.precioDisponible(prod.precioVenta) ? prod.precioVenta : prod.precioVenta2;
    },
    precioOriginal(prod) {
      return prod.precioVenta2;
    },
    precioDestacadoDisponible(prod) {
      return this.precioDisponible(this.precioDestacado(prod));
    },
    porcentajeDescuento(prod) {
      const oferta = Number(this.precioDestacado(prod) || 0);
      const original = Number(this.precioOriginal(prod) || 0);
      if (!oferta || !original || original <= oferta) return 0;
      return Math.round(((original - oferta) / original) * 100);
    },
    formatorPrecio(precio) {
      return new Intl.NumberFormat('es-CO').format(Number(precio || 0));
    },
    slugify(valor) {
      return String(valor || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "") || "catalogo";
    }
  }
};
</script>

<style scoped>
/* VARIABLES & GENERAL */
:root {
    --primary: #2c73d2;
    --secondary: #1b365d;
    --accent: #f5f5f5;
}

.home-maxica {
    font-family: 'Poppins', sans-serif;
    color: #2c3e50;
    overflow-x: hidden;
    /* Removed padding-top, handled globally now */
}

.section-title {
    font-weight: 700;
    color: #1b365d;
}

.divider {
    height: 4px;
    width: 60px;
    background: #000;
    border-radius: 0px;
}

/* HERO SECTION */
.hero-premium {
    /* Use a light/clean background gradient or image */
    background: #eff6ff; 
    position: relative;
    overflow: hidden;
    min-height: auto;
    display: flex;
    align-items: flex-start;
}

.hero-premium::before {
    content: '';
    position: absolute;
    top:0; left:0; right:0; bottom:0;
    /* Clean Minimalist Background: Texture or Abstract */
    background: url('https://images.unsplash.com/photo-1494253109108-2e30c049369b?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80') center/cover no-repeat;
    opacity: 0.6; /* Softer opacity for clean look */
    z-index: 0;
    filter: grayscale(100%); /* Make it black and white for extra clean look */
}

.hero-overlay-bg {
    position: absolute;
    top:0; left:0; right:0; bottom:0;
    background: linear-gradient(to bottom, rgba(255,255,255,0.7), rgba(255,255,255,1)); /* Fade to white at bottom */
    z-index: 1;
}

.hero-premium.hero.is-medium .hero-body,
.hero-body {
    width: 100%;
    z-index: 5;
    padding: 2.25rem 1rem 2.75rem;
}

.home-section-heading {
    margin-bottom: 1.4rem;
}

.home-section-heading .title {
    font-size: 1.55rem;
    margin-bottom: 0;
    letter-spacing: 0.18em;
    font-weight: 300;
    line-height: 1.2;
}

.home-catalog-action {
    margin-top: 1.75rem;
}

.home-collections-section {
    padding-top: 2rem;
    padding-bottom: 2.75rem;
}

.home-collections-title {
    font-size: 1rem;
    margin-bottom: 1.65rem;
    letter-spacing: 0.14em;
    line-height: 1.25;
}

.hero-glass {
    background: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(10px);
    padding: 3rem;
    border-radius: 20px;
    box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.18);
    display: inline-block;
    max-width: 800px;
}

.hero-title {
    background: linear-gradient(45deg, #2c73d2, #1b365d);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-bottom: 1rem;
}

.btn-glow {
    box-shadow: 0 0 20px rgba(44, 115, 210, 0.4);
    transition: all 0.3s ease;
}
.btn-glow:hover {
    transform: translateY(-2px);
    box-shadow: 0 0 30px rgba(44, 115, 210, 0.6);
}

.z-10 { z-index: 10; }
.relative-position { position: relative; }

/* PRODUCT CARDS */
.product-card {
    border-radius: 0px; 
    border: none;
    box-shadow: none; /* Minimalist clean look */
    transition: all 0.3s ease;
    overflow: hidden;
    height: 100%;
}
.product-card:hover {
    transform: translateY(-5px);
}
.hero-product-card .card-content {
    padding: 0.9rem 0.75rem 1rem;
}
.hero-product-card .title {
    max-width: 100%;
    font-size: 0.98rem !important;
    line-height: 1.18;
    font-weight: 700;
    letter-spacing: 0.02em !important;
}
.hero-product-card .price-container {
    margin-top: 0.32rem;
}
.hero-product-card .price-row {
    display: flex;
    justify-content: center;
    align-items: baseline;
    gap: 0.35rem;
    min-height: 1.1rem;
}
.hero-product-card .price-current {
    font-size: 0.9rem !important;
    line-height: 1.2;
    font-weight: 800;
    color: #111827;
}
.hero-product-card .price-before {
    font-size: 0.72rem !important;
    line-height: 1.2;
    color: #8c8c8c;
    text-decoration: line-through;
}
.hero-product-card .price-discount {
    margin-top: 0.1rem;
    font-size: 0.68rem;
    line-height: 1.15;
    font-weight: 700;
    color: #15803d;
}
.hero-product-card .price-dozen {
    margin-top: 0.1rem;
    font-size: 0.68rem;
    line-height: 1.15;
    color: #2c73d2;
}
.discount-tag {
    background: #111827;
    color: #fff;
    letter-spacing: 0;
    font-size: 0.62rem;
    padding: 0 6px;
    height: 1.65em;
}
.is-absolute-top-left {
    position: absolute;
    top: 10px; left: 10px;
    z-index: 2;
}
.overlay-product {
    position: absolute;
    top: 0; left: 0; width: 100%; height: 100%;
    background: rgba(255,255,255,0.4); /* Lighter overlay for clean look */
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s ease;
}
.product-card:hover .overlay-product {
    opacity: 1;
}

/* CATEGORY CARDS */
.category-card {
    border-radius: 12px;
    overflow: hidden;
    position: relative;
    cursor: pointer;
    box-shadow: 0 4px 15px rgba(0,0,0,0.1);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.category-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 25px rgba(0,0,0,0.15);
}
.category-overlay {
    position: absolute;
    top:0; left:0; right:0; bottom:0;
    background: rgba(0,0,0,0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.3s ease;
}
.category-card:hover .category-overlay {
    background: rgba(0,0,0,0.5);
}
.category-name {
    color: #fff;
    font-weight: 700;
    text-transform: uppercase;
    font-size: 1.1rem;
    letter-spacing: 1px;
    text-shadow: 0 2px 4px rgba(0,0,0,0.5);
    text-align: center;
    padding: 10px;
}

/* NAVIGATION LINKS */
.navbar-link, a.navbar-item {
    cursor: pointer;
}

/* Footer & Other components */
.testimonial-card {
    border: none;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0,0,0,0.03);
    padding: 20px;
}
.avatar-wrapper img {
    border: 3px solid #fff;
    box-shadow: 0 4px 10px rgba(0,0,0,0.1);
}

/* FOOTER */
.footer-custom {
    background: #1b365d;
    padding: 60px 0 30px;
    color: #fff;
    margin-top: 60px;
}
.footer-custom a:hover {
    color: #fff !important;
    text-decoration: underline;
}

@media (min-width: 769px) {
    .home-maxica {
        margin-top: 0;
    }

    .hero-premium.hero.is-medium .hero-body {
        padding-top: 2rem;
        padding-bottom: 2.25rem;
    }
}

@media (max-width: 768px) {
    .hero-premium {
        min-height: auto;
    }

    .hero-premium.hero.is-medium .hero-body {
        padding: 1.6rem 0.8rem 2rem;
    }

    .home-section-heading {
        margin-bottom: 1rem;
    }

    .home-section-heading .title {
        font-size: 1.9rem;
        letter-spacing: 0.16em;
    }

    .hero-product-card .card-content {
        padding: 0.75rem 0.55rem 0.85rem;
    }

    .hero-product-card .title {
        font-size: 0.82rem !important;
        line-height: 1.18;
    }

    .hero-product-card .price-current {
        font-size: 0.82rem !important;
    }

    .hero-product-card .price-before,
    .hero-product-card .price-discount,
    .hero-product-card .price-dozen {
        font-size: 0.64rem !important;
    }

    .home-catalog-action {
        margin-top: 1.25rem;
    }

    .home-collections-section {
        padding-top: 1.6rem;
        padding-bottom: 2.2rem;
    }

    .home-collections-title {
        margin-bottom: 1.25rem;
        letter-spacing: 0.12em;
    }
}
</style>

